import {Injectable} from '@angular/core';
import {MatPaginatorIntl} from '@angular/material/paginator';

/** Textos del paginador en español ("1 – 10 de 34" en vez de "1 – 10 of 34"). */
@Injectable()
export class PaginadorEs extends MatPaginatorIntl {
  itemsPerPageLabel = 'Filas por página';
  nextPageLabel = 'Página siguiente';
  previousPageLabel = 'Página anterior';
  firstPageLabel = 'Primera página';
  lastPageLabel = 'Última página';

  getRangeLabel = (pagina: number, tamano: number, total: number): string => {
    if (total === 0 || tamano === 0) {
      return '0 de ' + total;
    }
    const desde = pagina * tamano;
    const hasta = Math.min(desde + tamano, total);
    return (desde + 1) + ' – ' + hasta + ' de ' + total;
  }
}
